const MEDALLIA_FORM_ID = process.env.NEXT_PUBLIC_MEDALLIA_FORM_ID
export const loadMedalliaFeedbackModal = () =>
  window?.KAMPYLE_ONSITE_SDK?.loadForm(MEDALLIA_FORM_ID)
export const showMedalliaFeedbackModal = () => {
  window?.KAMPYLE_ONSITE_SDK?.showForm(MEDALLIA_FORM_ID)
}
export const initMedallia = () => {
  if (window.KAMPYLE_ONSITE_SDK) {
    loadMedalliaFeedbackModal()
  } else {
    window.addEventListener("neb_OnsiteLoaded", loadMedalliaFeedbackModal)
  }
}
